"use client";

import { useSearchParams } from "next/navigation";
import { Col, Row } from "@/utils/bootstrap";
import ReactPaginate from "react-paginate";
import SvgFirstLastArrow from "./pagination-icons/SvgFirstLastArrow";
import SvgPrevNextArrow from "./pagination-icons/SvgPrevNextArrow";
import { useIsMobile } from "@/hooks/useIsMobile";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { usePushQueryToRouter } from "@/utils/functions/pushQueryToRouter";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  pageCount: number;
  isSmall?: boolean;
}

const Paginate: React.FC<Props> = ({ pageCount, isSmall }) => {
  const t = useTranslation();
  const pushQueryToRouter = usePushQueryToRouter();
  const searchParams = useSearchParams();

  const mobile = useIsMobile();
  const isPC = !mobile;
  const currentPage = searchParams?.get("page")
    ? +searchParams?.get("page")!
    : 1;
  const pagginationHandler = (page: { selected: number }) => {
    pushQueryToRouter.pushQueryToRouter([
      { name: "page", val: page.selected + 1 },
    ]);
  };
  if (pageCount < 2) return null;
  return (
    <Row className="d-flex align-items-center justify-content-center paginate">
      <Col className="p-0 col-auto">
        <CustomButton
          type={BtnTypes.paginate}
          size={BtnSizes.large}
          radius={BtnRadius.medium}
          notAllowed={currentPage === 1}
          onClick={() => {
            pagginationHandler({ selected: 0 });
          }}
        >
          <SvgFirstLastArrow /> {isPC && !isSmall && t?.first_page}
        </CustomButton>
      </Col>
      <Col className="p-0 col-auto">
        <ReactPaginate
          prevRel={null}
          nextRel={null}
          prevPageRel={null}
          nextPageRel={null}
          activeClassName="active"
          breakClassName="break-me"
          containerClassName="pagination1"
          disabledClassName="disabled"
          disabledLinkClassName="disabled"
          nextClassName="prev-next"
          pageClassName="page1"
          previousClassName="prev-next"
          previousLinkClassName="link1"
          nextLinkClassName="link1"
          breakLabel="..."
          forcePage={currentPage - 1}
          pageCount={pageCount}
          marginPagesDisplayed={isPC && !isSmall ? 2 : 0}
          pageRangeDisplayed={isPC ? 3 : 0}
          onPageChange={pagginationHandler}
          previousLabel={
            <>
              <SvgPrevNextArrow />
              {isPC && !isSmall && t?.previous_page}
            </>
          }
          nextLabel={
            <>
              {isPC && !isSmall && t?.next_page}
              <SvgPrevNextArrow next />
            </>
          }
        />
      </Col>
      <Col className="p-0 col-auto">
        <CustomButton
          type={BtnTypes.paginate}
          size={BtnSizes.large}
          radius={BtnRadius.medium}
          notAllowed={currentPage === pageCount}
          onClick={() => {
            pagginationHandler({ selected: pageCount - 1 });
          }}
        >
          {isPC && !isSmall && t?.last_page}
          <SvgFirstLastArrow last />
        </CustomButton>
      </Col>
    </Row>
  );
};

export default Paginate;
